/**
 * @generated SignedSource<<a329bc581d6dc968512198bce932dd4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PreCoachRegistrationInput = {
  clientMutationId?: string | null | undefined;
  displayName: string;
  email: string;
  referral?: string | null | undefined;
};
export type PreCoachRegistrationMutation$variables = {
  input: PreCoachRegistrationInput;
};
export type PreCoachRegistrationMutation$data = {
  readonly preCoachRegistration: {
    readonly client_secret: string;
  } | null | undefined;
};
export type PreCoachRegistrationMutation = {
  response: PreCoachRegistrationMutation$data;
  variables: PreCoachRegistrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PreCoachRegistrationPayload",
    "kind": "LinkedField",
    "name": "preCoachRegistration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "client_secret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PreCoachRegistrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PreCoachRegistrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "87721f28f817f0a34ecb63f32cbc9d9d",
    "id": null,
    "metadata": {},
    "name": "PreCoachRegistrationMutation",
    "operationKind": "mutation",
    "text": "mutation PreCoachRegistrationMutation(\n  $input: PreCoachRegistrationInput!\n) {\n  preCoachRegistration(input: $input) {\n    client_secret\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dcdccab50c8de2194a666aa68abf5b5";

export default node;
